import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/organization/")({
	component: OrganizationIndexPage,
	ssr: false,
});

function OrganizationIndexPage() {
	return <Navigate replace to="/organization/settings" />;
}
